import { useCountdown } from '@/hooks/useCountdown';

const pad = (value: number) => String(value).padStart(2, '0');

export default function CountdownTimer({
  targetMs,
  tone = 'primary',
}: {
  targetMs: number;
  tone?: 'primary' | 'light';
}) {
  const { hours, minutes, seconds, done } = useCountdown(targetMs);

  const boxClass =
    tone === 'primary'
      ? 'bg-primary-500 text-background-50'
      : 'bg-background-50/15 text-background-50';

  if (done) {
    return (
      <span className="flex items-center gap-1.5 text-xs font-medium text-accent-600">
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-live-line" aria-hidden="true" />
        </span>
        即将开播
      </span>
    );
  }

  return (
    <span className="flex items-center gap-1.5" aria-label="距离开播倒计时">
      <span className="text-[11px] text-foreground-500">距开播</span>
      {[pad(hours), pad(minutes), pad(seconds)].map((unit, index) => (
        <span key={index} className="flex items-center gap-1.5">
          <span className={`rounded px-1.5 py-0.5 font-mono text-xs font-semibold tabular-nums ${boxClass}`}>
            {unit}
          </span>
          {index < 2 && <span className="text-xs text-foreground-400">:</span>}
        </span>
      ))}
    </span>
  );
}